<template>
  <div class="dft-title_text">
    <div class="attr-item-box" v-for="(item,index) in value" :key="index">
      <div class="attr-item-typedata" v-if="item.type == 'data'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="temp-box" v-if="item.tag == 'custom'">
            <div class="temp-item" :class="item.value == iiIndex?'active_temp-item':''" v-for="(ii,iiIndex) in item.options" :key="iiIndex"
              @click="item.value = iiIndex">
              <el-image v-if="item.value == iiIndex&&ii.img1" class="temp-item-img" :src="ii.img1" fit="contain"></el-image>
              <el-image v-else-if="ii.img2" class="temp-item-img" :src="ii.img2" fit="contain"></el-image>
              <div class="temp-item-name">{{ ii.name }}</div>
            </div>
          </div>
          <div class="addImgList" v-else-if="item.tag == 'imgList'">
            <div class="img_info">建议图片尺寸750*350。</div>
            <div class="imgList_box">
              <div class="imgList-item" v-for="(ii,iiIndex) in item.value" :key="iiIndex"
                >
                <div class="ii-img-box">
                  <el-image v-if="ii.img" class="ii-img" :src="ii.img" fit="scale-down"></el-image>
                  <div class="ii-img-btn">
                    <el-upload
                      class="avatar-uploader-d"
                      :action="$uploadURL"
                      :show-file-list="false"
                      :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex)}"
                      :before-upload="beforeUpload"
                    >
                      <div class="">
                        更换图片
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="ii-link-box">
                  <div class="ii-link-btn">
                    <i class="el-icon-top icon_btn" title="上移" v-if="iiIndex != 0" @click="moveUp(item.value,iiIndex)"></i>
                    <i class="el-icon-bottom icon_btn" title="下移" v-if="iiIndex != (item.value.length - 1)" @click="moveDown(item.value,iiIndex)"></i>
                    <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(item.value,iiIndex)"></i>
                  </div>
                  <el-radio-group v-model="ii.type" size="small" style="margin-top: -12px;">
                    <el-radio-button label="1" disabled title="暂不支持">链接</el-radio-button>
                    <el-radio-button label="2">跳转</el-radio-button>
                  </el-radio-group>
                  <div v-if="ii.type == '1'">
                    <div class="ii-link-info">链接设置</div>
                    <div class="ii-link">
                      <el-input v-model="ii.link" placeholder="暂不支持" disabled></el-input>
                    </div>
                  </div>
                  <div v-else>
                    <div class="ii-link-info">跳转设置</div>
                    <div class="ii-link">
                      <el-select v-model="ii.url" placeholder="请选择" filterable style="width: 100%;">
                        <el-option v-for="(llitem,index) in navigatelist" :key="index" :label="llitem.label" :value="llitem.value"
                          class="select-option" :disabled="llitem.disabled" :title="llitem.disabled?'暂不支持':''"></el-option>
                      </el-select>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <el-upload
              class="avatar-uploader-d"
              :action="$uploadURL"
              :show-file-list="false"
              :on-success="(res, file)=>{handleUploadSuccess(res, file,item)}"
              :before-upload="beforeUpload"
            >
              <div class="upload_btn">
                <i class="el-icon-plus" ></i>
                添加图片
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.type == 'style'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
            <!-- >>>图片广告 -->
          <el-radio-group v-if="item.sid == 'imageAd_s1'" v-model="item.value" size="small">
            <el-radio-button label="1">常规</el-radio-button>
            <el-radio-button label="2">投影</el-radio-button>
          </el-radio-group>
          <el-radio-group v-else-if="item.sid == 'imageAd_s2'" v-model="item.value" size="small">
            <el-radio-button label="0">方角</el-radio-button>
            <el-radio-button label="14px">圆角</el-radio-button>
          </el-radio-group>
          <el-slider v-else-if="item.sid == 'imageAd_s3'" v-model="item.value" :min="item.min" :max="item.max"
            show-input :show-input-controls="false" class="custon_slider" input-size="mini"></el-slider>
          <el-radio-group v-else-if="item.sid == 'imageAd_s4'" v-model="item.value" size="small">
            <el-radio-button label="cover">填充</el-radio-button>
            <el-radio-button label="contain">留白</el-radio-button>
          </el-radio-group>
          <el-radio-group v-else-if="item.sid == 'imageAd_s5'" v-model="item.value" size="small">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="2">否</el-radio-button>
          </el-radio-group>
            <!-- 图片广告<<< -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      navigatelist: [
        { label: '今日优惠', value: '1', disabled: false },
        { label: '新品展示', value: '2', disabled: false },
        { label: '爆款专区', value: '3', disabled: false },
        { label: '新人专享', value: '4', disabled: false },
        { label: '好物推荐', value: '5', disabled: false },
        { label: '会员专区', value: '6', disabled: false },
        { label: '团购专区', value: '7', disabled: false },
        { label: '砍价专区', value: '8', disabled: false },
        { label: '秒杀专区', value: '9', disabled: false },
        { label: '直播间', value: 'live', disabled: true }
      ],
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        [
          { label: '模板类型',
            value: 0,
            options: [
              { name: '一行一个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '轮播海报', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' }
            ],
            key: 'templateType',
            type: 'data',
            tag: 'custom'
          }, // 0
          {
            label: '添加图片', value: [], key: 'imgList', type: 'data', tag: 'imgList'
          }, // 1
          {
            label: '图片样式',
            value: '1',
            sid: 'imageAd_s1',
            showList: {
              '1': '常规',
              '2': '投影'
            },
            key: 'imgshadow',
            type: 'style',
            tag: 'radio'
          }, // 2
          {
            label: '边角样式',
            value: '0',
            sid: 'imageAd_s2',
            showList: {
              '0': '方角',
              '14px': '圆角'
            },
            key: 'border-radius',
            type: 'style',
            tag: 'radio'
          }, // 3
          {
            label: '页面边距',
            value: 0,
            sid: 'imageAd_s3',
            min: 0,
            max: 30,
            key: 'padding',
            type: 'style',
            tag: 'el-slider'
          }, // 4
          {
            label: '图片间距',
            value: 0,
            sid: 'imageAd_s3',
            min: 0,
            max: 30,
            key: 'margin-top',
            type: 'style',
            tag: 'el-slider'
          }, // 5
          {
            label: '填充样式',
            value: 'cover',
            sid: 'imageAd_s4',
            showList: {
              'cover': '填充',
              'contain': '留白'
            },
            key: 'fit',
            type: 'style',
            tag: 'radio'
          }, // 6
          {
            label: '直播样式',
            value: '2',
            sid: 'imageAd_s5',
            showList: {
              '1': '是',
              '2': '否'
            },
            key: 'fit',
            type: 'style',
            tag: 'radio'
          }// 7
        ]
      )
    }
  },
  watch: {
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },

    // 配置事件
    // 图片上传成功处理
    handleUploadSuccess (res, file, item) {
      const _imgUrl = file.response.data.url
      item.value.push(
        {
          img: _imgUrl,
          link: '',
          url: '',
          type: '2'
        }
      )
    },
    // 修改图片上传成功处理
    handleChangeUploadSuccess (res, file, ii, iiIndex) {
      const _imgUrl = file.response.data.url
      ii.img = _imgUrl
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
    // 上移
    moveUp (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex - 1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex + 1, 1, value[iiIndex])[0]
    },
    // 删除
    mDelete (value, iiIndex) {
      value.splice(iiIndex, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 110px;
              padding: 0 8px;
              display: flex;
              flex-direction: column;
              .ii-link-btn{
                display: flex;
                justify-content: flex-end;
                font-size: 18px;
                color: #969696;
                .icon_btn{
                  padding: 2px;
                  cursor: pointer;
                  margin: 4px;
                }
              }
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                margin-top: 4px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
</style>
